import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  const phone = "923063580306";

  return (
    <div className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 group flex items-center">
      {/* Modern Tooltip */}
      <span className="absolute right-full mr-4 bg-white text-gray-800 text-xs font-semibold px-4 py-2.5 rounded-xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-x-2 group-hover:translate-x-0 whitespace-nowrap pointer-events-none">
        Order via WhatsApp
        {/* Tooltip triangle tail */}
        <span className="absolute right-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 bg-white border-r border-b border-gray-100 rotate-[-45deg]"></span>
      </span>

      {/* Button */}
      <a
        href={`https://wa.me/${phone}`}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-target relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] text-white rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:shadow-[0_12px_40px_rgba(37,211,102,0.5)] hover:scale-110 hover:-translate-y-1 transition-all duration-300"
        aria-label="Chat on WhatsApp"
      >
        <span className="absolute w-full h-full bg-[#25D366] rounded-full animate-ping opacity-30"></span>
        <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8 fill-current z-10" strokeWidth={1} />
      </a>
    </div>
  );
}
